import React from '../helpers/react';
import { connect } from '../helpers/composeReducer.js';
import { pushPath } from 'redux-simple-router';
import { trigger } from '../helpers/events.js';
import {ACCOUNT_FLAGGED} from '../modules/apiWrapper.js';
import classList from 'ereader-core/dist/classList.js';

export const NoAccessSolution = React.createClass({
    triggerCTA : function() {
        trigger('noSubCTA', this.props.problemId);
    },

    gotoFirstProblem: function(){
        const chapterKey = this.props.use_id_identifier ? this.props.chapter.chapterId : this.props.chapter.chapterName;
        
        this.props.pushPath(this.props.buildRoute('chapter',{
            isbn13  : this.props.isbn13,
            chapter : chapterKey
        }));
    },

    getHeader : function() {
        let title = this.props.getDef('solution.title', {}, {
            problem_exists: this.props.problem_exists
        });

        return (<header key='header'><h3>
            {title}
        </h3></header>)
    },

    getCTADialog :  function() {
        const chapter = this.props.chapter.chapterName;
        const problem_name = this.props.problemName;

        let link = '';
        let title = this.props.getDef('no-sub.problem-info', {chapter, problem_name});
        let cta = this.props.getDef('no-sub.cta-button-text');

        if(this.props.solution_limit_exceeded) {
          title = this.props.getDef('no-sub.free-access-exceeded');
          cta = this.props.getDef('no-sub.free-access-cta');
        }

        if (this.props.show_sample_link) {
            link = <a onClick={this.gotoFirstProblem}>{this.props.getDef('no-sub.sample-solution')}</a>;
        }

        return (
            <section className='dialog'>
                <h1 className='title'>{title}</h1>
                <h2 className='subtitle'>{this.props.getDef('no-sub.subtitle')}</h2>
                <button className='simple-button cta' onClick={this.triggerCTA}>{cta}</button>
                {link}
            </section>
        )
    },

    getMockSteps : function(steps = 3) {
        let result = [];
        for (let i = 0; i < steps; i++) {
            result.push(
                <section className={'step mock-step mock-step-no-access mock-' + (i+1)} key={'mock_step_' + i}>
                    <header>
                        <h4 className="step-header">
                            <span className="step-num">{this.props.getDef('step.title', { index: i + 1 }) + ' '}</span>
                            <span className="step-total">{this.props.getDef('step.title-total', { total : steps })}</span>
                        </h4>
                    </header>
                    <div className="content"></div>
                </section>
            )
        }

        return result;
    },

    render : function() {
        const header = this.getHeader(),
            dialog = (this.props.access_restriction === ACCOUNT_FLAGGED) ? '' : this.getCTADialog(),
            mock_steps = this.getMockSteps();

        let mainClass = classList('no-sub-solution');
        return (
            <section className={mainClass}>
                { header }
                { dialog }
                { mock_steps }
            </section>
        );
    }
});

export function mapStateToProps(state){
    const problem = state.problem;
    return {
        ...problem,
        isbn13 : state.model.isbn13,
        show_sample_link : state.options.no_solution_show_sample_link,
        use_id_identifier : state.options.use_id_identifier,
        buildRoute : state.helpers.buildRoute,
        getDef : state.helpers.getDef
    };
}

export default connect(mapStateToProps, { pushPath })(NoAccessSolution);



// WEBPACK FOOTER //
// ./src/components/NoAccessSolution.js